<template>
  <div>
    <b-table
      :id="id"
      :fields="colunas"
      :items="itens"
      :per-page="metodoBusca ? null : tamanhoPagina"
      :current-page="metodoBusca ? null : paginaAtual"
      :head-variant="cabecalhoVariante"
      @row-dblclicked="doisClicksLinha"
    >
      <template v-for="slot in slots" :slot="slot" slot-scope="dados">
        <div :key="slot">
          <slot v-bind:item="dados" :name="slot" />
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="paginaAtual"
      :total-rows="totalLinhasComputada"
      :per-page="tamanhoPagina"
      :aria-controls="metodoBusca ? null : id"
      @change="paginar"
      align="center"
    ></b-pagination>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: "Tabela",
  props: {
    id: {
      type: String,
      default: "tabela",
    },
    colunas: {},
    dados: {},
    tamanhoPagina: {
      default: 10,
    },
    totalLinhas: {},
    cabecalhoVariante: {
      default: "dark",
    },
    metodoBusca: {
      default: null,
    },
  },
  data: () => ({
    itens: [],
    paginaAtual: 1,
    totalDados: 0,
  }),
  methods: {
    buscar(pagina) {
      if (!this.metodoBusca) return;

      this.metodoBusca()(this.tamanhoPagina, pagina)
        .then((response) => {
          this.itens = response.data.data.itens;
          this.totalDados = response.data.data.paginacao.totalDeElementos;
          this.$emit("buscou", this.itens);
        })
    },
    paginar(pagina) {
      this.buscar(pagina - 1);
      this.$emit("paginar", pagina - 1);
    },
    doisClicksLinha(item) {
      this.$emit("doisClicksLinha", item);
    },
  },
  mounted() {
    this.buscar(0);
  },
  watch: {
    dados: {
      handler: function (val) {
        if (val != null) {
          this.itens = val;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    totalLinhasComputada() {
      if (this.totalLinhas) return this.totalLinhas;
      if (this.metodoBusca) return this.totalDados;

      return this.itens.length;
    },
    slots: function () {
      let slots = [];
      slots.push(...Object.keys(this.$slots));
      slots.push(...Object.keys(this.$scopedSlots));
      return slots;
    },
  },
};
</script>
<style lang=""></style>
